  <template>
  <div class="modal" v-show="value">
    <div class="container">
      <Terms></Terms>
      <p>
        <!-- <button class="button up-button" @click.prevent="close">
          <i class="fas fa-arrow-left" aria-hidden="true"></i>
        </button> -->
      </p>
    </div>
  </div>
</template>

    <script>
import Terms from "./Terms.vue";
// import Terms from "@/components/Terms.vue";

export default {
  name: "Modal",
  component: {
    Terms,
    // Terms: () => import("./Terms.vue")
  },
  props: {
    value: {
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit("input", !this.value);
    },
  },
};
</script>
    <style lang="css" scoped>
.modal {
  display: block !important;
  position: relative;
  /* background-color: lightgray; */
}

#back-button {
  flex: 1;

  button {
    border-radius: 20px;
    padding: 8px 10px;
    background-color: #fff;
    border: 2px solid #fff;
    font-size: 16px;
    transition: background-color 0.2s;
    cursor: pointer;
    text-align: center;
    outline: none;
    color: #25b686;
  }

  button:hover {
    background-color: #eee;
  }
}
</style>